import { handleError } from '@helsenorge/framework-utils/cms-content-api-service';
import { getHelsenorgeUrl } from '@helsenorge/framework-utils/hn-proxy-service';
import { checkStatus, createBaseHeaders, createQueryString } from '@helsenorge/framework-utils/hn-service';
export const get = (endpoint, params = {}, signal) => {
    const hostName = getHelsenorgeUrl();
    const headers = createBaseHeaders('application/json', 'GET');
    const apiUrl = `${hostName}${endpoint}${createQueryString(params)}`;
    return fetch(apiUrl, {
        method: 'get',
        headers: headers,
        signal,
    })
        .then(response => checkStatus(response))
        .catch(error => handleError(error, apiUrl));
};
export const setSearchParams = (params, replace = true) => {
    const updatedParams = replace ? new URLSearchParams() : new URLSearchParams(window.location.search);
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined) {
            updatedParams.delete(key);
        }
        else {
            updatedParams.set(key, value);
        }
    });
    const newUrl = `${window.location.pathname}?${updatedParams.toString()}`;
    window.history.replaceState(null, '', newUrl);
};
